import React from 'react';
import moment from 'moment';
import DateRange from './Components/DateRange';
import queryString from 'query-string';
import NumberFormat from 'react-number-format';
import LocationOption from '../../../_components/Options/LocationOption'
import EventTypeOption from '../../../_components/Options/EventTypeOption';
import ProfessionalOption from '../../../_components/Options/ProfessionalOption';

import { history } from '../../../_helpers/history';
import { Component } from 'react';

class SearchFilters extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      date: '',
      eventStartDate: '',
      eventEndDate: '',
      invalidStart: false,
      invalidEnd: false,
      location: '',
      professional: '',
      eventType: '',
      invalidDate: false,
      invalidDOB: false,
      showDateRange: false,
    }

    this.setParams = this.setParams.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.toggleDateRange = this.toggleDateRange.bind(this);
  }

  componentDidMount() {
    this.setParams()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setParams();
    }
  }

  toggleDateRange(e) {
    e.preventDefault();
    if (this.state.showDateRange) {
      this.setState({ eventStartDate: "", eventEndDate: "" })
    } else {
      this.setState({ date: "" })
    }
    this.setState((prevState) => {
      return { ...prevState, showDateRange: !prevState.showDateRange }
    });
  }

  setParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("eventStartDate" in queryParams) ? true : false;

    this.setState({
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      showDateRange: showDateRange,
      date: !showDateRange ? queryParams.date || '' : '',
      eventStartDate: showDateRange && queryParams.eventStartDate ? new Date(queryParams.eventStartDate) || '' : '',
      eventEndDate: showDateRange && queryParams.eventEndDate ? new Date(queryParams.eventEndDate) || '' : '',
      location: queryParams.location ? parseInt(queryParams.location) : '',
      professional: queryParams.professional ? parseInt(queryParams.professional) : '',
      eventType: queryParams.eventType ? parseInt(queryParams.eventType) : '',
      status: queryParams.status || ''
    });
  }

  handleSearch() {
    let invalidDate = false,
      invalidDOB = false,
      invalidStart = false,
      invalidEnd = false;

    this.setState({ invalidDOB, invalidDate, invalidStart, invalidEnd });

    const dates = ["dateOfBirth"];

    if (!this.state.showDateRange) {
      dates.push("date");
    }
    else {
      const start = this.state.eventStartDate;
      const end = this.state.eventEndDate;

      if (!start && end) {
        return this.setState({ invalidStart: true })
      }
      if (start && !end) {
        return this.setState({ invalidEnd: true })
      }
    }

    for (const type of dates) {
      let invalid = false;

      const date = this.state[type] !== '' ? moment(this.state[type]).format("L") : '';

      if (date && date.replace(/\D/g, '').length !== 8) {
        invalid = true;
      }
      else if (date && !moment(date, 'MM/DD/YYYY').isValid()) {
        invalid = true;
      }

      if (invalid === true) {
        switch (type) {
          case "dateOfBirth":
            invalidDOB = true;
            this.setState({ invalidDOB });
            return;
          case "date":
            invalidDate = true;
            this.setState({ invalidDate });
            return;
          case "eventStartDate":
            invalidStart = true;
            this.setState({ invalidStart });
            return;
          case "eventEndDate":
            invalidEnd = true;
            this.setState({ invalidEnd });
            return;
          default:
            break;
        }
      }
    }

    if (!invalidDOB && !invalidDate && !invalidStart && !invalidEnd) {
      this.props.handleSearch(this.state);
    }
  }

  render() {
    return <div className="card axs-shadow">
      <div className="card-header">
        <h5>Search Filters</h5>
      </div>
      <div className="card-body">
        <form>
          <div className="form-group">
            <label htmlFor="patientFirstName">Patient First Name</label>
            <input onChange={e => this.setState({ firstName: e.target.value })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.firstName || ''}
              type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label htmlFor="patientLastName">Patient Last Name</label>
            <input onChange={(e) => this.setState({ lastName: e.target.value })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.lastName || ''}
              type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label htmlFor="patientDateOfBirth">Patient Date of Birth</label>
            <NumberFormat
              onValueChange={(e) => this.setState({ dateOfBirth: e.formattedValue })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.dateOfBirth || ''}
              format="##/##/####"
              mask="_"
              name="dateOfBirth"
              className={`form-control ${this.state.invalidDOB ? 'is-invalid' : ''}`}
              placeholder="__/__/____"
            />
          </div>

          <div className="form-group">
            <label htmlFor="date">Event Date</label>
            {this.state.showDateRange ?
              <DateRange
                startDate={this.state.eventStartDate}
                endDate={this.state.eventEndDate}
                invalidStart={this.state.invalidStart}
                invalidEnd={this.state.invalidEnd}
                handleSearch={this.handleSearch}
                setStartDate={(date) => this.setState({ eventStartDate: date })}
                setEndDate={(date) => this.setState({ eventEndDate: date })}
              />
              :
              <NumberFormat
                onValueChange={(e) => this.setState({ date: e.formattedValue })}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    this.handleSearch();
                  }
                }}
                value={this.state.date || ''}
                format="##/##/####"
                mask="_"
                name="date"
                className={`form-control ${this.state.invalidDate ? 'is-invalid' : ''}`}
                placeholder="__/__/____"
              />
            }
            <div className="mt-1">
              <a href="/" onClick={this.toggleDateRange}>
                {this.state.showDateRange ? "Date Only" : "Date Range"}
              </a>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="eventType">Event Type</label>
            <EventTypeOption defaultValue={this.state.eventType}
              handleSelected={(eventType) => {
                this.setState({ eventType });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="providerGroup">Location</label>
            <LocationOption defaultValue={this.state.location}
              handleSelected={(location) => {
                this.setState({ location });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="provider">Provider</label>
            <ProfessionalOption defaultValue={this.state.professional}
              handleSelected={(professional) => {
                this.setState({ professional });
              }} />
          </div>

          <button onClick={this.handleSearch} type="button" className="btn btn-primary btn-block">Search</button>

          <button onClick={() => history.push('/events')} type="button" className="btn btn-link btn-block text-center">Clear Filters</button>
        </form>
      </div>
    </div>
  }
}

export default SearchFilters;